import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { ASSETS_URL_REGEX, RESOURCES_URL_REGEX } from './cache-assets.http-interceptor';
import { Observable } from 'rxjs';

export abstract class NonStaticInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;
    if (!req.url.match(ASSETS_URL_REGEX) && !req.url.match(RESOURCES_URL_REGEX)) {
      return this.internalIntercept(req, next);
    }
    return next.handle(request);
  }

  protected abstract internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>;

}
